import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectProjects } from "../../redux/work/work.selectors";
import "./projects-section.styles.css";

const ProjectsSection = ({ projects }) => {
  const featured = projects.slice(0, 6);

  return (
    <section className="me-section">
      <div className="me-title-wrapper">
        <h2 className="h2">Selected work</h2>
      </div>
      <div className="projects-grid">
        {featured.map((project, index) => (
          <a
            key={project.id}
            href={project.link}
            target="_blank"
            rel="noreferrer"
            className={`project-card ${index === 0 ? "" : ""}`}
          >
            {project.bgUrl && (
              <div
                className="project-card-image"
                style={{ backgroundImage: `url(${project.bgUrl})` }}
              />
            )}
            <div className="project-card-content">
              <div className="content-title-group">
                <div className="h4"><strong>{project.title}</strong></div>
                <div className="h4 gold">{project.header}</div>
              </div>
              <div className="label gold">
                <div className="c label gold">Project</div>
              </div>
            </div>
            <p className="b2 m500 project-card-desc">{project.description[0]}</p>
          </a>
        ))}
      </div>
    </section>
  );
};

const mapStateToProps = createStructuredSelector({
  projects: selectProjects,
});

export default connect(mapStateToProps)(ProjectsSection);
